import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/material/new")({
  component: () => (
    <div className="size-full">
      <Outlet />
    </div>
  ),
});
